// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3a4rY","loaderOuter":"PageOverlayLoader_loaderOuter__2C-6K"};